import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Auth } from 'aws-amplify';
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import SyncLockIcon from '@mui/icons-material/SyncLock';
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import {
  Button,
  Drawer,
  List,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import useStore from "../hooks/useStore";
import StoreSettings from "./settingsComponents/StoreSettings";

const useStyles = makeStyles({
  list: {
    width: 300,
  },
  fullList: {
    width: "auto",
  },
  menuLink: {
    underline: "none",
    color: "black",
    textDecoration: "none",
  },
});

export default function NavLink({ text, url, isFeaturesAdmin, isAdmin }) {
  const classes = useStyles();
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const { storeId, selectedStoreConfiguration } = useStore();

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = (side) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <Link to="/" className={classes.menuLink}>
          <ListItem button key={0} className="menu-actions-container">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
        </Link>
      </List>
      <Divider />

      {isFeaturesAdmin ? (
        <>
          <List>
            <Link to="/settings" className={classes.menuLink}>
              <ListItem button key={0} className="menu-actions-container">
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Settings" />
              </ListItem>
            </Link>
          </List>
          <Divider />
        </>
      ) : null}

      {isAdmin ?
          localStorage.getItem("isInStore") ?
            <>
              <List
                onClick={async (e) => {
                  await localStorage.clear();
                  Auth.federatedSignIn({ customProvider: 'Okta' });
                }}
              >
                <ListItem button key={0} className="menu-actions-container">
                  <ListItemIcon>
                    <SyncLockIcon />
                  </ListItemIcon>
                  <ListItemText primary="Change to Okta" />
                </ListItem>
              </List>
              <Divider />
            </>
            :
            <>
              <List>
                <Link to="/logout" className={classes.menuLink}>
                  <ListItem button key={0} className="menu-actions-container">
                    <ListItemIcon>
                      <SyncLockIcon />
                    </ListItemIcon>
                    <ListItemText primary='Change to in store' />
                  </ListItem>
                </Link>
              </List>
              <Divider />
            </>
        :
        null
      }
      
      <List>
        <Link to="/logout" className={classes.menuLink}>
          <ListItem button key={0} className="menu-actions-container">
            <ListItemIcon>
              <AddCircleOutlineIcon />
            </ListItemIcon>
            <ListItemText primary="Log Out" />
          </ListItem>
        </Link>
      </List>

      {isAdmin && storeId && storeId != 1 ? (
        <>
          <Divider />
          <StoreSettings storeId={storeId} selectedStoreConfiguration={selectedStoreConfiguration} />
        </>
      ) : null}
      <Divider />
    </div>
  );

  return (
    <>
      <div>
        <Button onClick={toggleDrawer("left", true)}>
          {" "}
          <MenuRoundedIcon color="action" fontSize="large" />
        </Button>

        <Drawer 
          open={state.left}
          onClose={toggleDrawer("left", false)}
        >
          {sideList("left")}
        </Drawer>
      </div>
    </>
  );
}

NavLink.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
